<script>
	/**
	 * Slider + year display + play/reset buttons. Stateless w.r.t. timing:
	 * the parent owns whether autoplay is running (single source of truth)
	 * so we don't risk duplicate intervals. This component only reflects
	 * `playing` and reports user interactions back via callbacks.
	 */
	let { years, year, playing = false, pinned, onYearChange, onTogglePlay, onClearPin } = $props();

	const currentIdx = $derived(years.indexOf(year));
	const total = $derived(years.length);
	const showEvery = $derived(total > 8 ? 2 : 1);

	function onSliderInput(e) {
		onYearChange?.(years[+e.currentTarget.value]);
	}
</script>

<div class="controls ep-block-copy" role="group" aria-label="Controles">
	<div class="slider-block">
		<div class="year-display" aria-live="polite">{year}</div>
		<input
			type="range"
			class="year-slider"
			min="0"
			max={total - 1}
			step="1"
			value={currentIdx}
			aria-label="Seleccionar año electoral"
			oninput={onSliderInput}
		/>
		<div class="slider-ticks" aria-hidden="true">
			{#each years as y, i (y)}
				<span>{i % showEvery === 0 || i === total - 1 ? y : ''}</span>
			{/each}
		</div>
	</div>

	<div class="controls-buttons">
		<button
			type="button"
			class="play-btn"
			aria-pressed={playing}
			aria-label={playing ? 'Pausar reproducción' : 'Reproducir secuencia de años'}
			onclick={onTogglePlay}>{playing ? '⏸ Pausar' : '▶ Reproducir'}</button
		>

		<button
			type="button"
			class="reset-btn"
			disabled={pinned == null}
			aria-label="Quitar municipio destacado"
			onclick={onClearPin}>Quitar selección</button
		>
	</div>
</div>
